import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { ObjectId } from "../../../interfaces/common";
import { PipelineConfigAttrs } from "../../../interfaces/orion";
import { useConfigs, useTriggerProcessing } from "../../Orion/OrionQueries";
import { DialogProps } from "../useDialogs";

function ProcessDialog({
  payload,
  open,
  onClose,
}: DialogProps<{
  assetId: ObjectId;
  workspaceId: ObjectId;
  configId?: ObjectId;
}>) {
  const { mutate: triggerProcessing } = useTriggerProcessing();
  const { data: configs } = useConfigs();
  const [config, setConfig] = useState<PipelineConfigAttrs | null>(
    configs?.find((config) => config._id === payload.configId) ?? null
  );

  useEffect(() => {
    setConfig(
      configs?.find((config) => config._id === payload.configId) ?? null
    );
  }, [configs, payload.configId]);

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        Analyser à nouveau le dossier ?
      </DialogTitle>
      <DialogContent className="p-2">
        <Autocomplete
          sx={{ my: 2 }}
          slotProps={{ popper: { style: { zIndex: 1500 } } }}
          disablePortal
          size="small"
          options={
            configs?.filter(
              (config) => config.workspace_id === payload.workspaceId
            ) ?? []
          }
          getOptionLabel={(option) => option.name}
          onChange={(event, value) => setConfig(value)}
          value={config}
          renderInput={(params) => (
            <TextField {...params} label="Configuration" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button
          onClick={() => {
            triggerProcessing({
              assetId: payload.assetId,
              configId: config?._id,
            });
            onClose();
          }}
          autoFocus
        >
          Analyser
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProcessDialog;
